import {
  Typography,
  Grid,
  Button,
  Box,
  Card,
  CardContent,
  Chip,
  Tab,
  Tabs,
  Divider,
  Stack,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import { BeneModelDetailed } from "../../models/BeneModel";
import { useState } from "react";
import { useQueryClient, useMutation, useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  fetchNomeDescrizioneForEntity,
  tipologiaBeneUri,
  qualitaBeneUri,
  collezioneBeneUri,
  brandBeneUri,
  materialeBeneUri,
} from "../../api/statotipologia";
import { WithData, WithRecordID } from "../../models/shared/CommonModels";
import { NomeDescrizione } from "../../models/StatoTipologiaModel";
import {
  fetchTipologiaBeneSelectQueryKey,
  fetchQualitaBeneSelectQueryKey,
  fetchCollezioneBeneSelectQueryKey,
  fetchBrandBeneSelectQueryKey,
  fetchMaterialeBeneSelectQueryKey,
  fetchAllFinalConditionsQueryKey,
  fetchAvailableCredenzialiPortaleVenditaForBeneContrattoQueryKey,
  fetchBeneContrattoPortaleTableQueryKey,
  fetchDetailedBeneQuery,
} from "../../utils/QueryClient";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ReplayIcon from "@mui/icons-material/Replay";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  deleteBeneContrattoPortale,
  fetchPaginatedBeneContrattoPortale,
} from "../../api/benecontrattoportale";
import { BeneContrattoPortaleDetailedModel } from "../../models/BeneContrattoPortaleModel";
import { ManageHistory as ManageHistoryIcon } from "@mui/icons-material";
import PortaleVenditaHistory from "../benecontrattoportale/PortaleVenditaHistory";
import BenePortaleFormComponent from "../benecontrattoportale/BenePortaleFormComponent";
import { editBeneContratto } from "../../api/benecontratto";
import { AxiosError } from "axios";
import {
  BeneContrattoPutModel,
  BeneContrattoRequest,
} from "../../models/BeneContrattoModel";
import SalesDataFormComponent from "../benecontratto/SalesDataFormComponent";
import FotoBeneManager from "../foto/FotoBeneManager";
import { fetchFotoBene } from "../../api/fotobene";
import BeneFormComponent from "./BeneFormComponent";
import BeneCondizioneFormComponent from "../benecontratto/BeneCondizioneFormComponent";
import { fetchAllFinalConditions } from "../../api/condizioni";
import { LoadingButton } from "@mui/lab";
import { displayFormatted } from "../../utils/date";
import BeneStateHistory from "./BeneStateHistory";

// Hook per ottenere il conteggio foto
const useFotoCount = (id_bene_contratto: number): number => {
  const { data } = useQuery({
    queryKey: ["fotobene", id_bene_contratto],
    queryFn: () => fetchFotoBene(id_bene_contratto),
    refetchOnMount: true,
    enabled: !!id_bene_contratto,
  });

  if (!data || !data.data) return 0;
  return Array.isArray(data.data) ? data.data.length : 0;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

interface BeneNewDetailComponentParams {
  bene: BeneModelDetailed;
}

const BeneNewDetailComponent: React.FC<BeneNewDetailComponentParams> = ({
  bene,
}) => {
  const navigator = useNavigate();
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const openUpload = searchParams.get("openUpload") === "true";
  const [tabValue, setTabValue] = useState(openUpload ? 1 : 0);

  const condition2Color = [
    { id: "Valutazione", color: "warning" as const },
    { id: "Approvato", color: "info" as const },
    { id: "Restituito", color: "default" as const },
    { id: "Caricato", color: "default" as const },
    { id: "Venduto Direttamente", color: "primary" as const },
    { id: "Reso", color: "error" as const },
    { id: "Venduto", color: "success" as const },
    { id: "In Approvazione", color: "warning" as const },
  ];

  const colorMap = new Map<string, "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning">();
  condition2Color.forEach((data) => {
    colorMap.set(data.id, data.color);
  });

  const condizioneColor = colorMap.get(bene.benecontratto[0].condizione.nome) || "default";

  // Mappa dei colori del theme per il testo
  const colorThemeMap: Record<string, string> = {
    warning: "#ed6c02",
    info: "#0288d1",
    default: "#757575",
    primary: "#1976d2",
    error: "#d32f2f",
    success: "#2e7d32",
  };

  const [tipologiaBeneRecords, setTipologiaBeneRecords] = useState<
    NomeDescrizione[]
  >([]);
  const [qualitaBeneRecords, setqualitaBeneRecords] = useState<
    NomeDescrizione[]
  >([]);
  const [collezioneBeneRecords, setcollezioneBeneRecords] = useState<
    NomeDescrizione[]
  >([]);
  const [brandBeneRecords, setbrandBeneRecords] = useState<NomeDescrizione[]>(
    []
  );
  const [materialeBeneRecords, setmaterialeBeneRecords] = useState<
    NomeDescrizione[]
  >([]);

  const [finalStates, setFinalStates] = useState<string[]>([]);
  const [portaleInfo, setPortaleInfo] =
    useState<BeneContrattoPortaleDetailedModel>(undefined as any);
  const [showHistory, setShowHistory] = useState<boolean>(false);

  const [mainDataEditFormOpen, setMainDataEditFormOpen] =
    useState<boolean>(false);
  const toggleMainDataEditFormOpen = () =>
    setMainDataEditFormOpen(!mainDataEditFormOpen);

  const [conditionDataEditFormOpen, setConditionDataEditFormOpen] =
    useState<boolean>(false);
  const toggleConditionDataEditFormOpen = () =>
    setConditionDataEditFormOpen(!conditionDataEditFormOpen);

  const [sellPortalEditFormOpen, setSellPortalEditFormOpen] =
    useState<boolean>(false);
  const toggleSellPortalEditFormOpen = () =>
    setSellPortalEditFormOpen(!sellPortalEditFormOpen);

  const [salesDataEditFormOpen, setSalesDataEditFormOpen] =
    useState<boolean>(false);
  const toggleSalesDataEditFormOpen = () =>
    setSalesDataEditFormOpen(!salesDataEditFormOpen);

  // final conditions query
  useQuery({
    queryKey: [fetchAllFinalConditionsQueryKey],
    queryFn: () => {
      return fetchAllFinalConditions();
    },
    onSuccess: (getResponse) => {
      setFinalStates(getResponse.data.data.map((cr) => cr.nome));
    },
    refetchOnWindowFocus: false,
  });

  // bene contratto portale query
  useQuery(
    [fetchBeneContrattoPortaleTableQueryKey, 1, bene.benecontratto[0].id],
    () => {
      return fetchPaginatedBeneContrattoPortale(1, bene.benecontratto[0].id);
    },
    {
      keepPreviousData: true,
      onSuccess: (getResponse) => {
        setPortaleInfo(getResponse.data.data[0]);
      },
      refetchOnWindowFocus: false,
    }
  );

  const deletePortaleInfoMutation = useMutation({
    mutationFn: (x: WithData) => deleteBeneContrattoPortale(x),
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === fetchBeneContrattoPortaleTableQueryKey ||
          query.queryKey[0] ===
            fetchAvailableCredenzialiPortaleVenditaForBeneContrattoQueryKey,
      });
    },
  });

  // tipologia bene query
  useQuery({
    queryKey: [fetchTipologiaBeneSelectQueryKey],
    queryFn: () => {
      return fetchNomeDescrizioneForEntity(tipologiaBeneUri);
    },
    onSuccess: (getResponse) => {
      if (tipologiaBeneRecords.length <= 0) {
        setTipologiaBeneRecords(getResponse.data);
        if (getResponse.data.length <= 0) navigator("/bene", { replace: true });
      }
    },
    refetchOnWindowFocus: false,
  });

  // qualità bene query
  useQuery({
    queryKey: [fetchQualitaBeneSelectQueryKey],
    queryFn: () => {
      return fetchNomeDescrizioneForEntity(qualitaBeneUri);
    },
    onSuccess: (getResponse) => {
      if (qualitaBeneRecords.length <= 0) {
        setqualitaBeneRecords(getResponse.data);
        if (getResponse.data.length <= 0) navigator("/bene", { replace: true });
      }
    },
    refetchOnWindowFocus: false,
  });

  // collezione bene query
  useQuery({
    queryKey: [fetchCollezioneBeneSelectQueryKey],
    queryFn: () => {
      return fetchNomeDescrizioneForEntity(collezioneBeneUri);
    },
    onSuccess: (getResponse) => {
      if (collezioneBeneRecords.length <= 0) {
        setcollezioneBeneRecords(getResponse.data);
        if (getResponse.data.length <= 0) navigator("/bene", { replace: true });
      }
    },
    refetchOnWindowFocus: false,
  });

  // brand bene query
  useQuery({
    queryKey: [fetchBrandBeneSelectQueryKey],
    queryFn: () => {
      return fetchNomeDescrizioneForEntity(brandBeneUri);
    },
    onSuccess: (getResponse) => {
      if (brandBeneRecords.length <= 0) {
        setbrandBeneRecords(getResponse.data);
        if (getResponse.data.length <= 0) navigator("/bene", { replace: true });
      }
    },
    refetchOnWindowFocus: false,
  });

  // materiale bene query
  useQuery({
    queryKey: [fetchMaterialeBeneSelectQueryKey],
    queryFn: () => {
      return fetchNomeDescrizioneForEntity(materialeBeneUri);
    },
    onSuccess: (getResponse) => {
      if (materialeBeneRecords.length <= 0) {
        setmaterialeBeneRecords(getResponse.data);
        if (getResponse.data.length <= 0) navigator("/bene", { replace: true });
      }
    },
    refetchOnWindowFocus: false,
  });

  const portaleVisible = () => {
    for (const storico_record of bene.benecontratto[0]
      .storicocondizionebenecontratto)
      if (storico_record.condizione.aggiunta_portale) return true;
    return false;
  };

  const venditaVisible = () => {
    for (const storico_record of bene.benecontratto[0]
      .storicocondizionebenecontratto)
      if (storico_record.condizione.aggiunta_vendita) return true;
    return false;
  };

  const isFinalState = (state: string) => {
    for (let fs of finalStates) {
      if (fs === state) {
        return true;
      }
    }
    return false;
  };

  const editBeneContrattoMutation = useMutation({
    mutationFn: (x: WithRecordID) => editBeneContratto(x),
    onSuccess: () => {
      queryClient.invalidateQueries(fetchDetailedBeneQuery);
    },
    onError: (err: AxiosError) => {
      // handle error
    },
  });

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const InfoRow: React.FC<{ label: string; value: string; chip?: boolean }> = ({
    label,
    value,
    chip,
  }) => (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: "block" }}>
        {label}
      </Typography>
      {chip ? (
        <Chip label={value} size="small" />
      ) : (
        <Typography variant="body1" fontWeight={500}>
          {value}
        </Typography>
      )}
    </Box>
  );

  return (
    <>
      {/* Header Card */}
      <Card
        elevation={2}
        sx={{ mb: 3, background: "linear-gradient(90deg, #fff9c4 0%, #fdd835 100%)" }}
      >
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <IconButton
              onClick={() => navigator(-1)}
              sx={{ color: "rgba(0,0,0,0.7)", mr: 2 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" color="rgba(0,0,0,0.87)" fontWeight={700}>
                {bene.sottotipologiabene?.nome || bene.tipologiabene.nome}
                {bene.brandbene?.nome && ` - ${bene.brandbene.nome}`}
                {bene.sottotipologiabene && (
                  <Box component="span" sx={{ fontSize: "0.75em", fontWeight: 400, ml: 1 }}>
                    - {bene.tipologiabene.nome}
                  </Box>
                )}
              </Typography>
              <Typography variant="subtitle1" color="rgba(0,0,0,0.7)" sx={{ mt: 0.5, fontWeight: 700 }}>
                {bene.anagraficacliente.personafisica?.cognome}{" "}
                {bene.anagraficacliente.personafisica?.nome}
              </Typography>
            </Box>
            <Chip
              label={bene.benecontratto[0].condizione.nome}
              sx={{
                fontWeight: 700,
                fontSize: "2.125rem",
                height: 60,
                px: 3,
                bgcolor: "#f5f5f5",
                color: colorThemeMap[condizioneColor],
                border: "none",
              }}
            />
          </Box>

          {/* Quick Actions */}
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
            <LoadingButton
              disabled={bene.benecontratto[0].id_condizione !== 1}
              loading={finalStates.length <= 0}
              variant="contained"
              size="small"
              color="success"
              startIcon={<LocalOfferIcon />}
              onClick={() => setSalesDataEditFormOpen(true)}
            >
              Venduto
            </LoadingButton>

            <LoadingButton
              disabled={isFinalState(bene.benecontratto[0].condizione.nome)}
              loading={finalStates.length <= 0}
              variant="contained"
              size="small"
              startIcon={<ReplayIcon />}
              onClick={() => {
                let putRequest = {} as WithRecordID;
                let putModel = {} as BeneContrattoRequest;
                let putData = {} as BeneContrattoPutModel;
                putData.id_condizione = 2;
                putData.id_contratto = bene.benecontratto[0].id_contratto;
                putModel.benecontratto = putData;
                putRequest.data = putModel;
                putRequest.recordID = bene.benecontratto[0].id;
                editBeneContrattoMutation.mutate(putRequest);
              }}
              color="warning"
            >
              Restituito
            </LoadingButton>
          </Stack>
        </CardContent>
      </Card>

      {/* Tabs Navigation */}
      <Paper elevation={1} sx={{ mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": { fontWeight: 600, fontSize: "0.95rem" },
          }}
        >
          <Tab label="Informazioni Principali" />
          <Tab label={`Foto (${useFotoCount(bene.benecontratto[0].id)})`} />
          <Tab label="Storico Stati" />
          {portaleVisible() && <Tab label="Portale Vendita" />}
        </Tabs>

        {/* Tab 0: Informazioni Principali */}
        <TabPanel value={tabValue} index={0}>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={3}>
              {/* Prima Colonna: Informazioni Base */}
              <Grid item xs={12} md={4}>
                <Card variant="outlined" sx={{ p: 2, '& > *:last-child': { mb: 0 } }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                    <Typography variant="h6" color="primary" fontWeight={600}>
                      Informazioni Base
                    </Typography>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<EditIcon />}
                      onClick={() => setMainDataEditFormOpen(true)}
                    >
                      Modifica
                    </Button>
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                  <InfoRow label="Cliente" value={`${bene.anagraficacliente.personafisica?.cognome} ${bene.anagraficacliente.personafisica?.nome}`} />
                  <InfoRow label="Contratto" value={bene.benecontratto[0].contratto?.titolo || "Non associato"} />
                  <InfoRow label="Ubicazione" value={bene.ubicazionebene?.nome || "-"} />
                  <InfoRow label="Categoria" value={bene.tipologiabene.nome} />
                  <InfoRow label="Sotto-Categoria" value={bene.sottotipologiabene?.nome || "-"} />
                  <InfoRow label="Stato" value={bene.qualitabene.nome} />
                </Card>
              </Grid>

              {/* Seconda Colonna: Caratteristiche */}
              <Grid item xs={12} md={4}>
                <Card variant="outlined" sx={{ p: 2, '& > *:last-child': { mb: 0 } }}>
                  <Typography variant="h6" gutterBottom color="primary" fontWeight={600}>
                    Caratteristiche
                  </Typography>
                  <Divider sx={{ mb: 2 }} />

                  <InfoRow label="Brand" value={bene.brandbene?.nome || "-"} />
                  <InfoRow label="Collezione" value={bene.collezionebene?.nome || "-"} />
                  <InfoRow label="Materiale" value={bene.materialebene?.nome || "-"} />
                  <InfoRow label="Colore" value={bene.colorebene?.nome || "-"} />
                  <InfoRow label="Anno di Produzione" value={displayFormatted(bene.anno_produzione).split("/")[2]} />
                  <InfoRow label="Edizione Limitata" value={bene.edizione_limitata ? "Sì" : "No"} />
                </Card>
              </Grid>

              {/* Terza Colonna: Valutazione/Note e Dati Vendita */}
              <Grid item xs={12} md={4}>
                <Stack spacing={3}>
                  {/* Valutazione e Note */}
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom color="primary" fontWeight={600}>
                      Valutazione e Note
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    <InfoRow
                      label="Valutazione (Min / Max)"
                      value={`${bene.valutazione_minima} € / ${bene.valutazione_massima} €`}
                    />
                    <InfoRow label="Note" value={bene.note || "-"} />
                  </Card>

                  {/* Dati Vendita */}
                  {venditaVisible() && (
                    <Card variant="outlined" sx={{ p: 2 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                        <Typography variant="h6" color="primary" fontWeight={600}>
                          Dati Vendita
                        </Typography>
                        <LoadingButton
                          loading={finalStates.length <= 0}
                          variant="contained"
                          size="small"
                          startIcon={<EditIcon />}
                          onClick={() => setSalesDataEditFormOpen(true)}
                        >
                          Modifica
                        </LoadingButton>
                      </Box>
                      <Divider sx={{ mb: 2 }} />

                      <InfoRow
                        label="Data Di Vendita"
                        value={
                          bene.benecontratto[0].venditabenecontratto?.data_vendita
                            ? new Date(bene.benecontratto[0].venditabenecontratto.data_vendita).toLocaleDateString("it-IT")
                            : "-"
                        }
                      />
                      <InfoRow
                        label="Prezzo di Vendita"
                        value={`${bene.benecontratto[0].venditabenecontratto?.totale_lordo || "0"} €`}
                      />
                      <InfoRow
                        label="Prezzo Netto"
                        value={`${bene.benecontratto[0].venditabenecontratto?.totale_netto || "0"} €`}
                      />
                      <InfoRow
                        label="Note di Vendita"
                        value={bene.benecontratto[0].venditabenecontratto?.selling_notes || "-"}
                      />
                    </Card>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>

        {/* Tab 1: Foto */}
        <TabPanel value={tabValue} index={1}>
          <Box sx={{ p: 2 }}>
            <Card variant="outlined" sx={{ overflow: "visible" }}>
              <Box sx={{ p: 3 }}>
                <FotoBeneManager
                  id_bene_contratto={bene.benecontratto[0].id}
                  autoOpenUpload={openUpload}
                />
              </Box>
            </Card>
          </Box>
        </TabPanel>

        {/* Tab 2: Storico Stati */}
        <TabPanel value={tabValue} index={2}>
          <Box sx={{ p: 2 }}>
            <Card variant="outlined" sx={{ overflow: "visible" }}>
              <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
                <BeneStateHistory history={bene.benecontratto[0].storicocondizionebenecontratto} />
              </Box>
            </Card>
          </Box>
        </TabPanel>

        {/* Tab 3: Portale Vendita */}
        {portaleVisible() && (
          <TabPanel value={tabValue} index={3}>
            <Box sx={{ p: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                <Typography variant="h5" fontWeight={600}>
                  Portale Vendita
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Button
                    disabled={
                      !bene.benecontratto[0].condizione.aggiunta_portale ||
                      portaleInfo !== undefined
                    }
                    variant="contained"
                    color="success"
                    startIcon={<AddIcon />}
                    onClick={toggleSellPortalEditFormOpen}
                  >
                    Aggiungi
                  </Button>
                  <Button
                    disabled={
                      !bene.benecontratto[0].condizione.aggiunta_portale ||
                      portaleInfo === undefined
                    }
                    variant="contained"
                    startIcon={<EditIcon />}
                    onClick={toggleSellPortalEditFormOpen}
                  >
                    Modifica
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<ManageHistoryIcon />}
                    onClick={() => setShowHistory(!showHistory)}
                  >
                    {showHistory ? "Nascondi" : "Storico"}
                  </Button>
                  <Button
                    disabled={!bene.benecontratto[0].condizione.aggiunta_portale}
                    variant="contained"
                    color="error"
                    startIcon={<DeleteForeverIcon />}
                    onClick={() => {
                      const x = {} as WithData;
                      x.data = portaleInfo.id;
                      deletePortaleInfoMutation.mutate(x);
                    }}
                  >
                    Elimina
                  </Button>
                </Stack>
              </Box>

              {portaleInfo !== undefined ? (
                <>
                  <Card variant="outlined" sx={{ p: 3 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <InfoRow
                          label="Valutazione"
                          value={`${portaleInfo.valutazione} €`}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InfoRow
                          label="Nome Portale"
                          value={portaleInfo.credenzialiportalevendita.anagraficaportale.nome_portale}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: "block" }}>
                            Link Portale
                          </Typography>
                          <Typography
                            variant="body1"
                            fontWeight={500}
                            component="a"
                            href={portaleInfo.credenzialiportalevendita.anagraficaportale.link_portale}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: "primary.main", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                          >
                            {portaleInfo.credenzialiportalevendita.anagraficaportale.link_portale}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InfoRow
                          label="Credenziali"
                          value={portaleInfo.credenzialiportalevendita.credenziali_di_accesso}
                        />
                      </Grid>
                    </Grid>
                  </Card>

                  {showHistory && (
                    <Box sx={{ mt: 3 }}>
                      <PortaleVenditaHistory
                        history={portaleInfo.storicocambioprezzobene}
                      />
                    </Box>
                  )}
                </>
              ) : (
                <Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
                  <Typography color="text.secondary">
                    Nessun portale di vendita selezionato per questo bene
                  </Typography>
                </Paper>
              )}
            </Box>
          </TabPanel>
        )}
      </Paper>

      {/* Modals */}
      <BeneFormComponent
        initialData={bene}
        open={mainDataEditFormOpen}
        toggleOpen={toggleMainDataEditFormOpen}
        editEnabled={true}
      />

      <BeneCondizioneFormComponent
        initialData={bene}
        open={conditionDataEditFormOpen}
        toggleOpen={toggleConditionDataEditFormOpen}
        editEnabled={true}
      />

      <SalesDataFormComponent
        initialData={bene}
        open={salesDataEditFormOpen}
        toggleOpen={toggleSalesDataEditFormOpen}
      />

      {portaleVisible() && portaleInfo === undefined && (
        <BenePortaleFormComponent
          initialData={{} as BeneContrattoPortaleDetailedModel}
          bene={bene}
          open={sellPortalEditFormOpen}
          toggleOpen={toggleSellPortalEditFormOpen}
          editEnabled={false}
        />
      )}

      {portaleVisible() && portaleInfo !== undefined && (
        <BenePortaleFormComponent
          initialData={portaleInfo}
          bene={bene}
          open={sellPortalEditFormOpen}
          toggleOpen={toggleSellPortalEditFormOpen}
          editEnabled={portaleInfo !== undefined}
        />
      )}
    </>
  );
};

export default BeneNewDetailComponent;
